<template>
  <div class="d-flex flex-column align-center justify-center"
    style="height: 200px; background-color: #3EB83D"
  >
    <v-img 
      contain max-height="27px"
      src="@/assets/referra-white-logo-234x54.png"
    />

    <v-icon class="mt-3" size="100px" color="white">mdi-check-circle-outline</v-icon>
    
    <div class="mt-1 white--text" style="font-weight: bold; font-size: 24px; line-height: 1;">
      You're all set!
    </div>
  </div>
</template>

<script>


export default {
  name: 'QRConfirmationHeader',
}
</script>